// src/modules/LeadManagement/api/opportunityService.js
import axios from "axios";

const API_BASE_URL = "https://your-api.com/api/opportunities"; // Replace with actual backend URL

/**
 * Fetch all opportunities
 */
export const fetchOpportunities = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching opportunities:", error);
    throw error;
  }
};

/**
 * Fetch opportunities for a specific lead
 */
export const fetchOpportunitiesByLeadId = async (leadId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/lead/${leadId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching opportunities for lead ${leadId}:`, error);
    throw error;
  }
};

/**
 * Create a new opportunity
 */
export const createOpportunity = async (opportunityData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}`, opportunityData);
    return response.data;
  } catch (error) {
    console.error("Error creating opportunity:", error);
    throw error;
  }
};

/**
 * Update an existing opportunity
 */
export const updateOpportunity = async (opportunityId, opportunityData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/${opportunityId}`, opportunityData);
    return response.data;
  } catch (error) {
    console.error(`Error updating opportunity ${opportunityId}:`, error);
    throw error;
  }
};

/**
 * Delete an opportunity
 */
export const deleteOpportunity = async (opportunityId) => {
  try {
    await axios.delete(`${API_BASE_URL}/${opportunityId}`);
  } catch (error) {
    console.error(`Error deleting opportunity ${opportunityId}:`, error);
    throw error;
  }
};